import React from 'react';

export default function TriggerSettings({ cfg, update }) {
  return (
    <div className="mt-2 grid gap-2">
      <label className="grid gap-1 text-xs text-slate-700">
        Trigger Type
        <select className="nodrag w-full rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-xs text-slate-900 outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/20" value={cfg.triggerType || 'webhook_event'} onChange={(e) => update({ triggerType: e.target.value })}>
          <option value="webhook_event">Webhook Event</option>
          <option value="incoming_message">Incoming Message</option>
          <option value="scheduled_event">Scheduled Event</option>
          <option value="manual_run">Manual Run</option>
        </select>
      </label>
    </div>
  );
}
